import 'raf/polyfill';
import 'element-closest';

// Polyfill custom event for IE9,10,11
import 'custom-event-polyfill';
